import * as React from 'react';
import { setFeatureFlag, FeatureName } from 'owa-feature-flags';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Label } from 'office-ui-fabric-react/lib/Label';

const styles = require('./FeatureFlagsListItem.scss');
export interface Props {
    name: string;
    isOn: boolean;
    description?: string;
    noFilter: boolean;
}

@observer
export default class FeatureFlagsListItem extends React.Component<Props, {}> {
    render() {
        const { name, isOn, description, noFilter } = this.props;
        const showDescription = !!description && !noFilter;

        return (
            <div>
                <div className={styles.container} title={description}>
                    <Toggle
                        checked={isOn}
                        onText={''}
                        offText={''}
                        className={styles.toggle}
                        onChanged={value => setFeatureFlag(name as FeatureName, !isOn)}
                        title={name}
                    />
                    <Link
                        href={`https://osp.office.net/SubstrateFlex/Flex/flight/OutlookWeb/${name}`}
                        target="_blank">
                        {name}
                    </Link>
                </div>
                {showDescription && (
                    <div>
                        <Label disabled> {description}</Label>
                    </div>
                )}
            </div>
        );
    }
}
